/**
 * アコーディオンメニュー
 */
// import {TweenLite} from 'gsap';

export default class {
  constructor(targetClass, { // option
    activeClassName = "is-show",
  } = {}) {
    // selector
    this.targetList = document.querySelectorAll(targetClass);

    // className
    this.activeClassName = activeClassName;

    // initialize
    this.init();
  }


  /**
   *
   */
  init() {
    if(this.targetList.length) {
      return this.eachTargetList();
    }
  }


  /**
   * １つの要素ごとにクリックイベントを設定
   */
  eachTargetList() {
    for (let i = 0; i < this.targetList.length; i++) {
      const node = this.targetList[i];
      const nextNode = node.nextElementSibling;
      this.clickEvent(node, nextNode);
    }
  }


  /**
   * クリックイベントの処理
   * @param {*} el
   * @param {*} next
   */
  clickEvent(el, next) {
    el.addEventListener('click', () => {
      if(el.classList.contains(this.activeClassName)) {
        this.closeAccordion(el, next);
      } else {
        this.openAccordion(el, next);
      }
    });
  }


  /**
   * アコーディオンを閉じる処理
   */
  closeAccordion(el, next) {
    el.classList.remove(this.activeClassName);
    TweenLite.to(next, 0.2, {height: 0});
  }

  /**
   * アコーディオンを開く処理
   */
  openAccordion(el, next) {
    el.classList.add(this.activeClassName)
    TweenLite.to(next, 0.2, {height:"auto"});
    TweenLite.from(next, 0.2, {height:0});
  }
}